import { createFileRoute } from '@tanstack/react-router';
import Skills from '@/features/skills';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/skills')({
  component: SkillsRoute,
});

function SkillsRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.SkillView}>
      <Skills />
    </ProtectedRoute>
  );
}
